import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

export interface SpreadsheetLockedDialogProps {
  open: boolean;
  onClose: () => void;
}

const MESSAGE =
  'The spreadsheet is locked now. Please wait for the process to complete.';

/**
 * Alert modal shown when the user tries to edit while the sheet is locked (e.g. during enrichment).
 * Styled to match other app modals (e.g. EnrichmentConfirmationDialog).
 */
const SpreadsheetLockedDialog: React.FC<SpreadsheetLockedDialogProps> = ({
  open,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>Spreadsheet locked</DialogTitle>
      <DialogContent>
        <DialogContentText>{MESSAGE}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={(theme) => ({
            backgroundColor:
              theme.customColors?.themePrimary || theme.palette.primary.main,
            color: '#fff',
            '&:hover': {
              backgroundColor:
                theme.customColors?.themePrimary || theme.palette.primary.main,
              color: '#fff',
              filter: 'brightness(0.95)'
            }
          })}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SpreadsheetLockedDialog;
